import {
  Activity,
  AlignLeft,
  ArrowLeftRight,
  BadgeCheck,
  Banknote,
  BarChart3,
  Building2,
  Calculator,
  ClipboardCheck,
  Code,
  Coins,
  Component,
  FileDown,
  Fingerprint,
  FormInput,
  Globe,
  GraduationCap,
  Heading,
  Image,
  Info,
  Layers,
  Leaf,
  LineChart,
  ListChecks,
  ListOrdered,
  type LucideIcon,
  MoveVertical,
  PieChart,
  Receipt,
  Scale,
  ScanSearch,
  SeparatorHorizontal,
  ShieldAlert,
  ShieldQuestion,
  Sprout,
  Table2,
  Target,
  TrendingUp,
  Type,
  UserCheck,
  UserCircle,
  Users,
  Wallet,
  Youtube,
} from "lucide-react";

// Icon for every flow and PDF component type. Keyed by string so it covers
// both `ComponentType` (flow) and `PdfComponentType` (pdf) from one source.
const COMPONENT_ICONS: Record<string, LucideIcon> = {
  // Flow input
  field: FormInput,
  goal_input: Target,
  custom_portfolio: Layers,
  // Shared portfolio / charts
  risk_assessment: ShieldAlert,
  portfolio_display: Wallet,
  portfolio_xray: ScanSearch,
  asset_allocation: PieChart,
  portfolio_forecast: TrendingUp,
  historical_return: Activity,
  expected_value: LineChart,
  // Shared costs
  cost_table: Receipt,
  cost_chart: BarChart3,
  portfolio_costs: Banknote,
  product_costs: Coins,
  cost_benefit: Scale,
  // Shared client / KYC
  client_classification: BadgeCheck,
  client_preferences: ListChecks,
  sustainability: Leaf,
  product_assessment: GraduationCap,
  quiz: ClipboardCheck,
  quiz_results: ClipboardCheck,
  financial_situation: Calculator,
  wealth_plan: Sprout,
  goal_list: Target,
  account_cash_overview: Wallet,
  cash_transfers: ArrowLeftRight,
  trapets_lookup: ShieldQuestion,
  sumsub_verification: Fingerprint,
  enin_lookup: Building2,
  group_members: Users,
  client_parties: UserCheck,
  // Shared formatting / media
  image: Image,
  spacer: MoveVertical,
  // Flow-only formatting
  text_block: Type,
  youtube_video: Youtube,
  iframe: Globe,
  embed: Code,
  file: FileDown,
  // PDF-only
  text: AlignLeft,
  heading: Heading,
  advisor_image: UserCircle,
  page_break: SeparatorHorizontal,
  table: Table2,
  table_of_contents: ListOrdered,
  goal_info: Info,
};

export function getComponentIcon(type: string): LucideIcon {
  return COMPONENT_ICONS[type] ?? Component;
}
